import React from "react";
import { Route, Redirect } from "react-router-dom";
import { InteractionStatus } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { FullscreenSpinner } from "../component/Util/FullscreenSpinner";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const { accounts, inProgress } = useMsal();
  const isAuthenticated = accounts && accounts.length > 0;

  return (
    <Route
      {...rest}
      render={(props) => {
        if (inProgress !== InteractionStatus.None) {
          return <FullscreenSpinner tip="Loading..." />;
        }
        if (!isAuthenticated) {
          return (
            <Redirect
              to={{ pathname: "/login-email", state: { from: props.location } }}
            />
          );
        }
        return <Component {...props} />;
      }}
    />
  );
};

export default ProtectedRoute;
